import React from 'react'

function Label({label}) {
  return <label>{label}</label>
}

export default Label